module.exports = __webpack_public_path__ + "img/ninja_corner.7d2905b7.png";